import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '../assets/icons/icon_cancelled.svg'


const _hoisted_1 = { class: "<sm:w-full <bsl:ml-0px <sm:transform-none <sm:px-[calc(50%-150px)] <sm:h-180px h-142px <sm:h-150px <lg:h-120px <lg:pt-10px" }
const _hoisted_2 = { class: "font-500 relative text-48px <lg:text-24px <sm:text-20px uppercase whitespace-nowrap" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "absolute top-0 w-160px left-0 transform-gpu translate-x-1/2 -translate-y-5px <lg:translate-x-0px <lg:-translate-y-35px <lg:scale-70"
}
const _hoisted_4 = { class: "mt-20px lowercase text-22px <lg:text-14px w-full leading-28px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      (_ctx.removed)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}